import { render, staticRenderFns } from "./ComingSoonAddOn.vue?vue&type=template&id=db8fead6&"
import script from "./ComingSoonAddOn.vue?vue&type=script&lang=js&"
export * from "./ComingSoonAddOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports